<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { valueOutOfRange } from '../../../helpers/utilities';
	import { onSettingsResponse } from '../../../helpers/device_settings_helpers';
	import { real_id } from '../../../helpers/interface_helpers';
		//Services
	import { gen2Request } from '../../../services/gen_2_http_reqs';
	//Design system components
	import { Input, Button, Text } from '@Shelly/shelly-design-system';
	//Types
	import type { SettingRequest } from '../../../types/requests/settings/setting';
	import type { Device } from '../../../types/Device';

	export let device: Device,
		settings: any,
		thrMin: number,
		thrMax: number,
		unit: 'pulses' | 'seconds' | '%',
		settingType: 'count_rep_thr' | 'freq_window' | 'freq_rep_thr';

	const id = real_id(device.id),
		component = 'input:2';

	let waitForResponse = false,
		value = settings?.[component]?.[settingType];

	const saveThr = async () => {
			waitForResponse = true;
			if (value != settings?.[component]?.[settingType]) {
				const res: SettingRequest = await gen2Request(device, `input.SetConfig`, {
					id: 2,
					config: { [settingType]: value },
				});
				if (res?.isok) {
					settings[component][settingType] = value;
					devices_settings.update_devices_settings(id, settings);
				}
				onSettingsResponse(res, device);
			}
			waitForResponse = false;
		},
		infoLabels = {
			count_rep_thr: {
				i18n: 'sub_title_input_counter_report_threshold',
				default:
					'Report threshold is the number of pulses the device counts before it reports hooks/actions, to scripts, mqtt or other side channels.',
			},
			freq_window: {
				i18n: 'sub_title_input_counter_frequency_window',
				default: 'Interval in seconds, used for frequency measurement.',
			},
			freq_rep_thr: {
				i18n: 'sub_title_input_counter_frequency_report_threshold',
				default:
					'Frequency report threshold is the change in frequency that the device sees before it reports hooks/actions, to scripts, mqtt or other side channels.',
			},
		};

	$: errors = valueOutOfRange(value, thrMin, thrMax);
</script>

<Text styleType="body-small" class="mb-s"
	>{$format(infoLabels[settingType].i18n, {
		values: { min: thrMin, max: thrMax },
		default: infoLabels[settingType].default,
	})}</Text
>

<Input
	aria-label={settingType == 'count_rep_thr'
		? $format('input_counter_report_threshold', {
				default: 'Input Counter report threshold',
			})
		: settingType == 'freq_window'
			? $format('input_frequency_measurement_window', {
					default: 'Input Frequency measurement window',
				})
			: $format('input_frequency_report_threshold', {
					default: 'Input Frequency report threshold',
				})}
	size="m"
	class="mb-s"
	icon="fas fa-calculator"
	bind:value
	error={errors
		? $format('min_max_error_description', {
				values: { min: thrMin, max: thrMax },
				default: 'Value must be between {min} and {max}.',
			})
		: ''}
	id="input-926s97v"
/>

<Text styleType="body-small" class="mb-s">
	{$format('min_max_unit_range', {
		default: `(Minimum: ${thrMin} ${unit}, Maximum: ${thrMax} ${unit})`,
		values: { min: `${thrMin} ${unit}`, max: `${thrMax} ${unit}` },
	})}
</Text>
<Button
	size="m"
	width="full"
	loading={waitForResponse}
	disabled={errors}
	class="text-uppercase"
	on:click={saveThr}>{$format('button_save', { default: 'Save' })}</Button
>
